import { render, staticRenderFns } from "./SortingItemContainer.vue?vue&type=template&id=2b1f3752&"
import script from "./SortingItemContainer.vue?vue&type=script&lang=js&"
export * from "./SortingItemContainer.vue?vue&type=script&lang=js&"
import style0 from "./SortingItemContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports